import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

const QueueDropdown = ({
    endpointName,
    onChange,
    value,
    id,
    name,
    className,
    disabled,
}) => {
    let selectDom = null

    selectDom = <select disabled={disabled} value={Number(value)} onChange={onChange} id={id} name={name} className={className || "form-control"} >
        <option value={1}>1</option>
        <option value={2}>2</option>
        <option value={3}>3</option>
        <option value={4}>4</option>
        <option value={5}>5</option>

    </select>

    value = parseInt(value)
    return selectDom
}

function mapStateToProps(state, ownProps) {
    // default to false if not specified
    let showInactive = ownProps.hasOwnProperty("showInactive") ? ownProps.showInactive : false
    return {
        endpoints: state.endpoints,
        onChange: ownProps.onChange,
        endpointName: ownProps.endpointName,
        value: ownProps.value,
        id: ownProps.id,
        name: ownProps.name,
        showInactive
    }
}

export default withRouter(connect(mapStateToProps)(QueueDropdown))


// WEBPACK FOOTER //
// ./src/components/utilities/QueueDropdown.js